import { IMeetingDto, TModifyRecurringType } from '@utils';
import { AxiosResponse } from 'axios';
import { observable, action, makeObservable } from 'mobx';
import { Service } from 'typedi';

interface IMessageDialogParams {
  message: string;
  isPlaner?: boolean;
  onCancel?: () => void;
  onAccept?: () => void;
  onReject?: () => void;
}

interface IChangeMeetingDialogParams {
  isShow: boolean;
  isDelete: boolean;
  isIntervalChanged: boolean;
  isDateChanged: boolean;
  handleChange?: (type: TModifyRecurringType) => Promise<AxiosResponse<IMeetingDto, any>>;
  onCancel?: () => void;
}

@Service()
export class MessageDialogViewModel {

  @observable.deep params: IMessageDialogParams = {
    message: '',
    isPlaner: false,
  };

  @observable changeParams: IChangeMeetingDialogParams = {
    isShow: false,
    isDelete: false,
    isIntervalChanged: false,
    isDateChanged: false,
  };

  @observable isShow = false;

  constructor() {
    makeObservable(this);
  }

  @action open = (params: IMessageDialogParams) => {
    this.params = params;
    this.isShow = true;
  };

  @action openChange = (
    isDelete: boolean,
    isIntervalChanged = false,
    isDateChanged = false,
    handleChange?: (type: string) => Promise<AxiosResponse<IMeetingDto, any>>,
    onCancel?: () => void,
  ) => this.changeParams = { isShow: true, isDelete, isIntervalChanged, isDateChanged, handleChange, onCancel };

  @action close = () => {
    this.isShow = false;
    this.params.isPlaner = false;
  };

  @action closeChange = () => this.changeParams.isShow = false;

  @action onAccept = () => {
    this.params.onAccept();
    this.close();
  };

  @action onCancel = () => {
    this.params.onCancel && this.params.onCancel();
    this.close();
  };

  @action onReject = () => {
    this.params.onReject && this.params.onReject();
    this.close();
  };
}
